import { dashboardHLTypes } from './actionTypes';

export const getTokenIframe = () => {
  return {
    type: dashboardHLTypes.GET_TOKEN_IFRAME,
  };
};
export const getGenericTokenIframe = (payload: any) => {
  return {
    type: dashboardHLTypes.GET_GENERIC_TOKEN_IFRAME,
    payload
  };
};

export const getTokenIframeSuccess = (payload: any) => ({
  type: dashboardHLTypes.GET_TOKEN_IFRAME_SUCCESS,
  payload,
});

export const getTokenIframeFail = (error: any) => ({
  type: dashboardHLTypes.GET_TOKEN_IFRAME_FAIL,
  payload: error,
});
